module.exports = __webpack_public_path__ + "img/branchIcon.642962a0.png";